import { render } from "./TextValue.vue?vue&type=template&id=425a3dd8"
import script from "./TextValue.vue?vue&type=script&lang=js"
export * from "./TextValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__